import React from 'react'
import { useWatch } from 'react-hook-form'
import { FormField } from '../forms/FormField'
import { SelectField } from '../forms/SelectField'
import { YES_NO_OPTIONS } from './profileStepOptions'
import type { FnaFormValues } from '../../contracts/fnaFormSchema'

/**
 * Step 6: Estate planning intent and instrument coverage. The amount field
 * is gated on `estateToHeirs === 'yes'` to mirror the LLM conversation flow.
 *
 * @returns JSX.Element The estate step
 */
export function EstateStep(): JSX.Element {
  const estateToHeirs = useWatch<FnaFormValues, 'estateToHeirs'>({ name: 'estateToHeirs' })
  return (
    <>
      <h2>Estate &amp; Legacy</h2>
      <SelectField<FnaFormValues>
        name="estateToHeirs"
        label="Do you plan to leave an estate to heirs?"
        options={YES_NO_OPTIONS}
      />
      {estateToHeirs === 'yes' && (
        <FormField<FnaFormValues>
          name="amountEstate"
          label="Approximate estate amount"
          type="number"
          placeholder="0"
          inputMode="decimal"
        />
      )}
      <SelectField<FnaFormValues>
        name="will"
        label="Do you have a will?"
        options={YES_NO_OPTIONS}
      />
    </>
  )
}
